import { query } from '../../../../muster-react/src';
import backLinkSchema from './back-link.schema';
import BackLink from './back-link';

export default query(backLinkSchema)(BackLink);

